<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col>
            <v-card
              flat
              class="rounded-lg mt-3 primary--text px-6 mouse-cursor"
            >
              <v-row class="text-start">
                <v-col md="3">
                  <span>
                    {{ $t("user.subRoles.role") }}
                  </span>
                </v-col>

                <v-col md="8">
                  <span>
                    {{ $t("user.subRoles.permissions") }}
                  </span>
                </v-col>

                <v-col md="1" class="text-center"> </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row v-if="!loading && subRoles.length" :key="reRender" class="mt-3">
          <v-col cols="12" v-for="(data, index) in subRoles" :key="index">
            <SubRoleCard
              :assignable-permissions="assignablePermissions"
              :sub-role="data"
              @editSubRole="editSubRole"
              @deleteSubRole="removeSubRole"
              @updateErr="onError('update')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !subRoles.length"
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col>
            {{ $t("noItems") }}
          </v-col>
        </v-row>

        <v-row v-else-if="loading && !subRoles.length">
          <v-col>
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SubRoleCard from "@/app/user-module/components/SubRoleCard";

import { deleteSubRole } from "../methods/deleteSubRole.js";

export default {
  name: "SubRoleList",
  components: { SubRoleCard },
  props: {
    assignablePermissions: {
      type: Array,
      default: () => [],
    },
    subRoles: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      reRender: 0,
    };
  },
  methods: {
    removeSubRole(id) {
      const msg =
        this.$i18n.locale === "ar"
          ? "سيتم حذف هذا الدور بشكل دائم. هل أنت متأكد من الاستمرار؟"
          : "This role will be deleted permanently. Are you sure to continue?";

      this.$dialog
        .confirm(msg)
        .then(() => {
          deleteSubRole(id).then(res => {
            if (res.data) this.$emit("reFetch");
            if (res.error) {
              this.onError("delete");
            }
          });
        })
        .catch(_ => {});
    },
    onError(type) {
      let msg = null;
      if (type === "delete") {
        msg = this.$t("deleteFailed");
      }
      if (type === "update") {
        msg = this.$t("updateFailed");
      }
      this.$emit("responseErr", msg);
    },
    editSubRole(val) {
      if (val) {
        this.$emit("editSubRoleVal", val);
      }
    },
  },
};
</script>
